import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconCardComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      <rect fill="none" height="14" rx="2" stroke="currentColor" width="20" x="2" y="5" />
      <path d="M2 10h20" stroke="currentColor" />
    </SvgIcon>
  );
};

IconCardComponent.displayName = 'IconCard';

const IconCard = memo(IconCardComponent);

export default IconCard;
